
import { BiZoomIn } from 'react-icons/bi'
import UserAppContext from '../../hook/UserAppContext'
import Empty from '../empty/Empty'
import './gallery.css'

const Gallery = ({isGallery, isSetModal, isSetObj}) => {

      if(!isGallery) return 

      const {user} = UserAppContext()
      const {galleries} = user.user 

      if(galleries.data){
            return (
                  <Empty text={"Oops! Not Found"}/>
            )
      }

      const openModal = (item) => {
            isSetModal(true)
            isSetObj(item)
      }
      
      return (
            <div className={isGallery ? "page_content show" : "page_content"}>
                  <div className="content_scroll">
                        <div className="content_gallery">
                              {
                                    galleries.map((item, index) => (
                                          <div className="gallery_row" key={index}>
                                                <img src={item.image} alt={item.description} />
                                                <button className="btn_modal" onClick={() => openModal(item)}><BiZoomIn/></button>
                                          </div>
                                    ))
                              }
                              
                        </div>
                  </div>
            </div>
      )
}

export default Gallery
